import axios from 'axios'

export const getUserChats = (limit: number, offset: number) =>
  axios.get(`/chatMessage/usermessages?limit=${limit}&offset=${offset}`)
